import React from 'react';
import styled from 'styled-components';

import useEvent from '@src/hooks/useEvent';

import Carousel from '@src/components/common/carousel';
import Details from './details';

const MediaWrapper = styled.div`
	display: flex;
	flex-direction: column;

	@media ${props => props.theme.device.lgDesktop} {
		width: calc(100% - 412px);
		margin-right: 10px;
		box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
	}

	@media ${props => props.theme.device.desktop} {
		width: calc(100% - 350px);
		margin-right: 10px;
		box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
	}
`;

const Media = (): JSX.Element => {
	const { event: { viewed_count, photos, categories, tags: eventTags } } = useEvent();
	const imageLinkList = photos.map(photo => ({
		link: photo.link,
		altTitle: photo.alt_title,
	}));
	const keywords = [...categories, ...eventTags];

	return (
		<MediaWrapper>
			<Carousel maxImageAmount={6} imageLinkList={imageLinkList} />
			<Details
				keywords={keywords}
				viewedCount={viewed_count}
			/>
		</MediaWrapper>
	);
};

export default Media;
